import { render } from "./eventCard.vue?vue&type=template&id=c0c156a4&scoped=true"
import script from "./eventCard.vue?vue&type=script&lang=js"
export * from "./eventCard.vue?vue&type=script&lang=js"

import "./eventCard.vue?vue&type=style&index=0&id=c0c156a4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c156a4"]])

export default __exports__